module.exports = __webpack_public_path__ + "img/honor_sg_001.5fc02d8.webp";